import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ASSETS } from "../../lib/content";

export const BrandBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const scale = useTransform(scrollYProgress, [0, 1], [1.12, 1]);

  return (
    <section
      ref={ref}
      data-testid="brand-banner"
      className="relative bg-ad-black overflow-hidden"
    >
      <div className="relative w-full">
        <motion.img
          style={{ scale }}
          src={ASSETS.bannerSposi}
          alt="Atelier Divine — Sposa e Sposo"
          className="w-full h-auto object-contain md:h-[42vw] md:max-h-[620px] md:min-h-[220px] md:object-cover"
        />
        <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
      </div>
    </section>
  );
};
